
import fetch from '@/utils/fetch'
import {API_PATH} from '@/config/env'
export const listFeature = (objJson) => fetch(API_PATH + '/exam/auth/practical/listFeature', objJson, 'POST')
export const practicalSave = (objJson) => fetch(API_PATH + '/exam/auth/practical/save', objJson, 'POST')



// WEBPACK FOOTER //
// ./src/api/practical.js